import { baseApi } from "redux/baseAPI";

export const guidelinesApi = baseApi.injectEndpoints({
    tagTypes: ["Clinical Guidelines"],
    endpoints: (builder) => ({
        getGuidelinesCounter: builder.query({
            query: (body)=>{
                console.log('bodyfy:', body)
                return {
                    url: `/get_clinical_guidelines_count_new.json`,
                    method: 'GET',
                    params: {pid: body.pid}
                }
            },
            transformResponse: (response, meta, arg) => response.response,
            providesTags: 'Clinical Guidelines'
        }),

        getGuidelinesListing: builder.query({
            query: (body) =>{
                return {
                    url: `/get_clinical_guidelines_new.json`,
                    method: 'GET',
                    params: {pid: body.pid}
                }
            },
            transformResponse: (response, meta, arg) => response.response
        })
        ,
        getGuidelinesFollowUpList: builder.query({
            query: (id) =>{
                return {
                    url: `/get_measures_value_set_code.json`,
                    method: 'GET',
                    params: {measure_header_id: id}
                }
            },
            transformResponse: (response, meta, arg) => response.response
        })
        ,
        updateClinicalGuidelines: builder.mutation({
            query: ({pid,body})=>{
                console.log('request body:', body, ".........pid:", pid)
                return{
                    url: `/cds/update_clinical_guidelines.json`,
                    method: 'POST',
                    data: body,
                    params: {pid: pid, tbt: 0}
                }
            },
            transformResponse: (response, meta, arg) => response.response,
            async onQueryStarted({ id, ...patch }, { dispatch, queryFulfilled }) {
                const patchResult = dispatch(
                  guidelinesApi.util.updateQueryData("getGuidelinesListing", id, (draft) => {
                    Object.assign(draft, patch);
                  })
                );
                try {
                  await queryFulfilled;
                } catch {
                  patchResult.undo();
                }
              },
              invalidatesTags: (result, error, { id }) => [{ type: "Clinical Guidelines", id }]
            
        })
    
    })
})

export const { useGetGuidelinesCounterQuery, useGetGuidelinesListingQuery, useGetGuidelinesFollowUpListQuery, useUpdateClinicalGuidelinesMutation } = guidelinesApi; 